<template>
  <div class="noti-complete" v-if="showNoti">
    {{title}}
    <img src="@/assets/images/close-x-white.svg" alt="" @click="onCloseNoti" />
  </div>
</template>

<script setup>
const props = defineProps({
  title: String,
  showNoti: Boolean
});

const emit = defineEmits(['onClose']);

function onCloseNoti() {
  emit('onClose');
}
</script>

<style lang="scss" scoped>
.noti-complete {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 14px 0 13px;
  font-size: 14px;
  font-weight: normal;
  line-height: 19px;
  text-align: center;
  background: #fd7444;
  color: #ffffff;
  border-radius: 5px;
  transition: all linear 0.4s;
  img {
    position: absolute;
    right: 10px;
    width: 18px;
  }
}
</style>
